import { PORTFOLIO_ASSET_ALLOCATION } from '../../../enums/AssetAllocation';

export const DEFAULT_ASSET_TYPES = [
  PORTFOLIO_ASSET_ALLOCATION.CANADIAN_EQ,
  PORTFOLIO_ASSET_ALLOCATION.US_EQ,
  PORTFOLIO_ASSET_ALLOCATION.CASH,
  PORTFOLIO_ASSET_ALLOCATION.FIXED_INCOME,
  PORTFOLIO_ASSET_ALLOCATION.FOREIGN_EQ,
  PORTFOLIO_ASSET_ALLOCATION.OTHER,
] as string[];

export const TIME_SERIES = Object.freeze({
  WEEKLY_ROLLING: 'WEEKLY_ROLLING',
  MONTHLY_ROLLING: 'MONTHLY_ROLLING',
});

export type MERBreakdown = {
  mer?: number;
  fee?: number;
  tax?: number;
  total?: number;
};
